/** English Privacy Policy copy (VizHacks public site). */
const privacyEn = {
  intro: {
    h2: "Introduction",
    p: [
      'This Privacy Policy describes how VIZHACKS LTD ("VizHacks", "we", "us", or "our") collects, uses, stores, and protects personal information when you use our website and related services (the "Services"). It applies to visitors and to individuals who submit enquiries or service requests through our forms.',
      "We are committed to protecting your privacy and handling data responsibly. Please read this policy carefully. If you do not agree with it, you should not use the Services.",
    ],
  },
  controller: {
    h2: "Data controller",
    p1: "The data controller responsible for your personal information is:",
    address: ["VIZHACKS LTD", "167–169 Great Portland Street, 5th Floor", "London, W1W 5PF, England"],
    p2: {
      before: "For privacy-related requests, contact us using our",
      linkLabel: "contact form",
      after: "or the details shown in the footer of this website.",
    },
  },
  collect: {
    h2: "Information we collect",
    provided: {
      h3: "Information you provide",
      p1: "When you submit a contact message or a service request, we may collect information you enter, such as:",
      items: [
        "Name and contact details (for example email address and phone number, if provided)",
        "Company or organisation name, where relevant",
        "Country or location fields, if the form asks for them",
        "The content of your message, requirements, or project description",
        "Any other information you choose to include in free-text fields",
      ],
      p2: "Please do not submit special categories of personal data (such as health information, government ID numbers, or similar) unless we explicitly ask for them. If you voluntarily include such information, we will treat it only as needed to handle your enquiry and in line with this policy.",
    },
    automated: {
      h3: "Automated technical data",
      p1: "When you use the Services, our servers and security systems may automatically collect technical information, including:",
      items: [
        "Internet protocol (IP) address",
        "Browser type and version (user agent)",
        "Date and time of requests",
        "Diagnostic and security logs associated with service operation",
      ],
    },
    cookies: {
      h3: "Cookies",
      p1: "We do not use non-essential or marketing cookies on this website for the purposes described in typical cookie banners. Essential technical measures required to operate the site, maintain security, or support administrator access may still apply as provided by your browser or hosting environment.",
    },
  },
  use: {
    h2: "How we use your information",
    p1: "We use personal information for the following purposes:",
    items: [
      "To respond to your enquiries and manage service requests",
      "To operate, maintain, and improve the Services",
      "To run automated or semi-automated analysis of request content (for example to summarise, triage, or support our consultants), where such features are enabled — this may process the text you submitted",
      "To protect the security and integrity of our systems, including detecting abuse, fraud, unauthorised access attempts, and other activity that may harm the Services or other users",
      "To comply with legal obligations and enforce our terms",
    ],
    p2: "Where required by applicable law (for example UK GDPR / GDPR), we rely on appropriate legal bases such as performance of a contract or pre-contract steps, legitimate interests (including security and service improvement), and, where applicable, consent.",
  },
  securityMonitoring: {
    h2: "Security and abuse prevention",
    p1: "We implement technical and organisational measures designed to protect personal information. We may log and analyse technical data and usage patterns to detect and respond to malicious activity, including attempted intrusions, denial-of-service patterns, or scripted abuse of public forms. Such processing is carried out to protect our infrastructure and users.",
  },
  sharing: {
    h2: "Sharing and processors",
    p1: "We do not sell your personal information. We may share data with trusted service providers who assist us in operating the Services, for example:",
    items: [
      "Hosting and infrastructure providers",
      "Email or communications tools used to respond to you",
      "Providers that support automated analysis or AI-assisted processing of request content, where we use such features",
    ],
    p2: "These parties process data on our instructions and under contractual safeguards appropriate to the nature of the processing. We may also disclose information if required by law or to protect our rights and the safety of others.",
  },
  transfers: {
    h2: "International transfers",
    p1: "Your information may be processed in the United Kingdom and in other countries where our providers operate. Where personal data is transferred outside the UK or EEA, we use appropriate safeguards as required by applicable law (such as standard contractual clauses or equivalent mechanisms).",
  },
  retention: {
    h2: "Retention",
    p1: "We retain personal information only for as long as necessary to fulfil the purposes described in this policy, including legal, accounting, or reporting requirements. Retention periods may vary depending on the nature of the data and our relationship with you.",
  },
  rights: {
    h2: "Your rights",
    p1: "Depending on your location, you may have rights under data protection law, which can include the right to access, correct, delete, or restrict processing of your personal data, the right to object to certain processing, the right to data portability, and the right to lodge a complaint with a supervisory authority.",
    p2: {
      before: "To exercise these rights, contact us using our",
      linkLabel: "contact form",
      after: "or the details in the site footer. We may need to verify your identity before responding.",
    },
  },
  children: {
    h2: "Children",
    p1: "The Services are not directed at children under the age where parental consent is required for data processing in your jurisdiction. We do not knowingly collect personal information from children in that context.",
  },
  changes: {
    h2: "Changes to this policy",
    p1: 'We may update this Privacy Policy from time to time. The "Last updated" date at the top of this page will be revised when we make material changes. We encourage you to review this page periodically.',
  },
  related: {
    h2: "Related terms",
    p1: {
      before: "Our",
      termsLink: "Terms of Use",
      after:
        "govern use of the website and Services and should be read together with this policy.",
    },
  },
};

export default privacyEn;
